export default {
  path: '/entryGroupNotification',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'entryGroupNotification',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
